<svg
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="7 4 10 16"
  width="24px"
  fill="currentColor"
>
  <path d="M0 0h24v24H0z" fill="none" />
  <path
    d="M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
  />
</svg>

<!-- <svg
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="0 0 24 24"
  width="24px"
  fill="currentColor"
>
  <path d="M0 0h24v24H0z" fill="none" />
  <path
    d="M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
  />
</svg> -->

<!-- <svg
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="4 1 16 21"
  width="24px"
  fill="currentColor"
>
  <path d="M0 0h24v24H0z" fill="none" />
  <path d="M0 0h24v24H0V0z" fill="none" />
  <path
    d="M8 19h3v3h2v-3h3l-4-4-4 4zm8-15h-3V1h-2v3H8l4 4 4-4zM4 9v2h16V9H4z"
  />
  <path d="M4 12h16v2H4z" />
</svg> -->

<!-- <svg
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="0 0 24 24"
  width="24px"
  fill="currentColor"
>
  <path d="M0 0h24v24H0z" fill="none" />
  <path d="M0 0h24v24H0V0z" fill="none" />
  <path
    d="M8 19h3v3h2v-3h3l-4-4-4 4zm8-15h-3V1h-2v3H8l4 4 4-4zM4 9v2h16V9H4z"
  />
  <path d="M4 12h16v2H4z" />
</svg> -->
